import React from 'react';
import { ShieldCheck, X, Settings } from 'lucide-react';
import { useUI, useAuth } from '../context/AppContext';
import { STORAGE_KEYS, USER_ROLE, Z_INDEX } from '../utils/constants';

const CookieBannerUI = () => {
  const { showCookieBanner, setShowCookieBanner, setCurrentPage, activeModal } = useUI();
  const { loggedInUser } = useAuth();

  const surveyOpen =
    loggedInUser?.role === USER_ROLE.STUDENT && Boolean(loggedInUser?.pendingReview);

  if (!showCookieBanner || activeModal || surveyOpen) return null;

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEYS.COOKIE_CONSENT, 'accepted');
    setShowCookieBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem(STORAGE_KEYS.COOKIE_CONSENT, 'rejected');
    setShowCookieBanner(false);
  };

  const linkClass =
    'text-blue-700 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 underline underline-offset-2 font-semibold transition-colors';

  return (
    <div
      role="region"
      aria-label="Çerez ve Gizlilik Tercihleri"
      className="print:hidden fixed inset-x-0 bottom-0 px-3 sm:px-6 pb-[max(0.75rem,env(safe-area-inset-bottom))] pl-[max(0.75rem,env(safe-area-inset-left))] pr-[max(0.75rem,env(safe-area-inset-right))] pointer-events-none"
      style={{ zIndex: Z_INDEX.cookieBanner }}
    >
      <div className="pointer-events-auto max-w-4xl mx-auto bg-white dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-600 rounded-2xl shadow-[0_12px_40px_rgba(15,23,42,0.25)] px-4 sm:px-6 py-4 sm:py-5 flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 bg-blue-50 dark:bg-blue-500/15 border border-blue-100 dark:border-blue-500/30 rounded-xl flex items-center justify-center shrink-0">
            <ShieldCheck size={20} className="text-blue-600 dark:text-blue-400" />
          </div>
          <div className="min-w-0">
            <p className="font-extrabold text-[15px] text-slate-900 dark:text-white mb-1">
              Çerez ve Gizlilik Tercihleri
            </p>
            <p className="text-[13px] text-slate-600 dark:text-slate-300 leading-relaxed">
              Platform işlevselliği için yalnızca zorunlu yerel depolama (localStorage) kullanılmaktadır; üçüncü taraf analitik çerez kullanılmamaktadır.{' '}
              <button type="button" onClick={() => setCurrentPage('kvkk')} className={linkClass}>
                KVKK Aydınlatma Metni
              </button>{' '}
              ile{' '}
              <button type="button" onClick={() => setCurrentPage('kvkk')} className={linkClass}>
                Çerez Politikamızı
              </button>{' '}
              okuyabilirsiniz.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 shrink-0 w-full md:w-auto">
          <button
            type="button"
            onClick={handleReject}
            className="flex-1 md:flex-none flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 text-sm font-bold transition-colors"
          >
            <X size={15} /> Reddet
          </button>
          <button
            type="button"
            onClick={() => setCurrentPage('kvkk')}
            className="hidden md:flex items-center gap-2 px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 text-sm font-semibold transition-colors"
          >
            <Settings size={14} /> Tercihler
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="flex-1 md:flex-none flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white text-sm font-bold transition-colors"
          >
            <ShieldCheck size={15} /> Kabul Et
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBannerUI;
